export default import.meta.ROLLDOWN_FILE_URL_CUJHuIoTqlZPZnd$CSWT8g